var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"framework"},[_c('div',{staticClass:"alerts"},_vm._l((_vm.currentAlerts),function(alert,index){return _c('awsui-v-flash',{key:index,attrs:{"type":alert.type,"dismissible":true}},[_c('div',{domProps:{"innerHTML":_vm._s(alert.message)}})])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }